import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#091529] text-[#F5F0E8] py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand */}
          <div>
            <h3
              className="text-2xl font-serif mb-4 text-[#F5F0E8]"
              style={{ fontFamily: 'Pacifico, serif' }}
            >
              ig-night
            </h3>
            <p className="text-sm text-[#6B83A8] leading-relaxed">
              Concrete candles infused with pure essential oils. Each scent is a
              destination. Light one and travel.
            </p>
          </div>

          {/* About */}
          <div>
            <h4 className="text-sm font-medium uppercase tracking-wider text-[#D4C5A9] mb-4">
              About
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#story"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  Our Story
                </a>
              </li>
              <li>
                <a
                  href="#craft"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  How We Craft
                </a>
              </li>
              <li>
                <Link
                  to="/sustainability"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  Sustainability
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-medium uppercase tracking-wider text-[#D4C5A9] mb-4">
              Connect
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/ig.night"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://pinterest.com/ignight"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
                >
                  Pinterest
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#162D52] pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-[#6B83A8]">
            © {new Date().getFullYear()} ig-night. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy-policy"
              className="text-xs sm:text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-xs sm:text-sm text-[#6B83A8] hover:text-[#F5F0E8] transition-colors cursor-pointer"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
